import { render, staticRenderFns } from "./vfg-vstextarea.vue?vue&type=template&id=c716c738"
import script from "./vfg-vstextarea.vue?vue&type=script&lang=js"
export * from "./vfg-vstextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports